import React from 'react';
import styles from '../styles.module.css';
import { faNum, faPlate } from '@/functions/formats';
import { useLocale, useTranslations } from 'next-intl';
import Checkbox from '@/components/common/CheckBox';
import { Car, Plate, setState } from '@/commonTypes';
import MainIcons from '@/icons/main';
import { useLayoutContext } from '@/context/LayoutContext';
import { TRIGGERS } from '@/api/global';
import AppLink from '@/components/common/AppLink';

export default function CarSwitcherBox({
  cars = [],
  activeCar,
  setActiveCar,
  platesCount,
}: {
  cars?: any;
  activeCar?: any;
  setActiveCar?: setState<Car | undefined>;
  platesCount?: string | number;
}) {
  const locale = useLocale();
  const tCommon = useTranslations('common');
  const changeActiveCar = (c: Car) => {
    // setActiveCar && setActiveCar(c);
    setDefaultFunction(c);
  };
  const { setSearchedPlate, setTrigger, setDefaultFunction } = useLayoutContext();

  console.log('activeCaris====', activeCar, cars);
  return (
    <>
      <div className={styles.menuHead}>
        <span className={styles.menuTitle}>{tCommon('changePlate.title')}</span>
        <span className={styles.menuCount}>{platesCount + ' ' + tCommon('car')}</span>
      </div>

      <div className={styles.list}>
        {cars?.map((c: Car, i: number) => (
          <div
            key={i}
            className={`${styles.row} ${activeCar && c?.id == activeCar?.id && styles.activeRow}`}
            onClick={() => {
              changeActiveCar(c);
            }}
          >
            <Checkbox
              title={c?.name ? c?.name : 'بی نام'}
              checked={activeCar && activeCar?.id == c?.id}
              onChange={() => {
                changeActiveCar(c);
                setDefaultFunction(c);
                // setSearchedPlate && setSearchedPlate();
              }}
              wrapper={styles.checkbox}
              titleClass={`${styles.rowName}`}
            />

            <div className={styles.rowText}>
              <div dir="ltr" className={styles.rowPlate}>
                {faPlate(c?.plate)}
              </div>
            </div>
            <AppLink className={styles.edit} href={`/sub-users?plateId=${c?.id}`}>
              <MainIcons.editIcon width={'15px'} height="15px" />
            </AppLink>
          </div>
        ))}
      </div>

      <div className={styles.foot}>
        <AppLink title={tCommon('addCar')} href="/sub-users" className={styles.footAdd}>
          {tCommon('addCar')}
        </AppLink>
        <AppLink
          title={'گاراژ'}
          href="/sub-users?garage=true"
          className={styles.footManage}
          // onClick={() => {
          //   setTrigger(TRIGGERS.SUBUSER_MODAL);
          // }}
        >
          {tCommon('manageAll')}
        </AppLink>
      </div>
    </>
  );
}
